<div class="container">
  <span class="icon-container">
    <svg-icon src="assets/icons/xmark.svg" [svgStyle]="{ 'width.px': 64 }"></svg-icon>
  </span>
  <ng-container [ngSwitch]="reason">
    <ng-container *ngSwitchCase="'level'">
      <h1 class="title">You need {{ requiredLevel }} access</h1>
      <p class="text">This page needs {{ requiredLevel }} access to GAP, which your account does not have.</p>
      <p class="text-support">Ask a GAP administrator to grant it, then try again.</p>
    </ng-container>
    <ng-container *ngSwitchCase="'unreachable'">
      <h1 class="title">Access could not be checked</h1>
      <p class="text">A GAP service did not answer, so your access to this page is not known.</p>
      <p class="text-support">Try again in a moment.</p>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <h1 class="title">No access to GAP</h1>
      <p class="text">Your account does not have access to the GAP application.</p>
      <p class="text-support">Ask a GAP administrator to grant you access, then try again.</p>
    </ng-container>
  </ng-container>
  <button nz-button nzType="primary" [nzLoading]="checking" (click)="tryAgain()">Try again</button>
  <button *ngIf="reason === 'level'; else signOutButton" nz-button nzType="default" (click)="goBack()">Go back</button>
  <ng-template #signOutButton>
    <button nz-button nzType="default" (click)="signOut()">Sign out</button>
  </ng-template>
</div>
